var map = {
	"./Beverage.png": 8371,
	"./Boilers.png": 7541,
	"./Chemical.png": 3114,
	"./DistilearyPlant.png": 2097,
	"./Refinary.png": 7213,
	"./SugarFactories.png": 6110,
	"./services": 9971,
	"./services.json": 9971
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8698;